import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatPopoverHide = createCustomElementWrapper('kat-popover-hide', 'KatPopoverHide', {}, {});
